import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from "react-dom";
import { BrowserRouter as Router, useLocation, useHistory } from "react-router-dom";
import { ToastProvider, useToasts } from 'react-toast-notifications';
import HeaderTools from '../../Header/HeaderTools';
import apiService from '../../../Services/apiServices';
import { confirmAlert } from 'react-confirm-alert';
import DataTable from '../Tables/DataTable';
import { MDBInput } from 'mdb-react-ui-kit';
import Select from 'react-select';
import globals from '../../../Services/globals';
import Modal from "react-bootstrap/Modal";
import Search from '../../Search/Search';
import Switch from "react-switch";
import helper from '../../../Services/helper';
import { reference } from '@popperjs/core';


const AdministrationForm = props => {
    let location = useLocation();
    const history = useHistory()

    const [referenceData, setReferenceData] = useState([]);
    const [addReference, setAddReference] = useState(false);
    const { addToast } = useToasts();
    const [errors, setErrors] = useState();
    const [referenceObj, setReferenceObj] = useState(props.model)

    const [search, setSearch] = useState();

    const [show, setShow] = useState(false);

    const modalClose = () => {
        setShow(false);
        setAddReference(false)
        // setNewClick(0)
    }
    const modalShow = () => setShow(true);

    const [newClick, setNewClick] = useState(0)

    const headers = props.headers;
    const table = props.table;
    const selectQuery = props.selectQuery;

    const showAddReference = () => {
        setAddReference(!addReference)
    }

    const getReferenceData = async (table) => {
        apiService()
            .get(selectQuery ? selectQuery : table)
            .then((response) => {
                if (response.success) {
                    setReferenceData(response.data)
                } else {
                    setReferenceData([])
                    console.log('Error:' + response.errorMessage);
                }
            });
    }

    const getType = (pathname) => {
        let type;
        if (pathname === 'categories') type = 'category';
        if (pathname === 'units') type = 'unit';
        setReferenceObj({ ...referenceObj, type: type })
    }

    const addNewReference = () => {
        setAddReference(true);
        setReferenceObj(props.model)
        setShow(true);
        setErrors('');
        if (addReference) {
            getFocus();
        }
    }

    const editReference = (item) => {

        if (props.table === 'vatlevel') {
            var params = `&vat=${item.id}`;
            apiService()
                .query("vatExist", params)
                .then((response) => {
                    if (response.success) {
                        let res = response.data.length
                        if (res === 0) {
                            editReferenceItem(item)
                        } else {
                            addToast('Nuk mund të editoni Taksen sepse ka artikull apo faturë që përmban këtë vlerë', { appearance: 'warning', autoDismiss: true, });
                        }
                    }
                    else {
                        alert("Error: getting Pagesat" + response.errorMessage);
                    }
                });

        } else {
            editReferenceItem(item);
        }

    }

    const editReferenceItem = (item) => {
        headers.forEach(header => {
            header.backData ? props.backData(header.options ? header.options?.find(v => v.value == item?.[header.key]) : '') : ''
        });

        setAddReference(true);
        setReferenceObj(item);
        setShow(true);
        //setReferenceObj({...referenceObj, id: item.id, name: item.name})
        // if(addReference){
        //     getFocus();
        // }
    }

    const getFocus = () => {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        document.getElementById("elemFirst")?.focus();
    }

    const selectStyles = {
        control: (provided, state) => ({
            ...provided,
            background: '#fff',
            borderColor: '#9e9e9e',
            minHeight: '28.59px',
            height: '28.59px',
            boxShadow: state.isFocused ? null : null,
        }),

        valueContainer: (provided, state) => ({
            ...provided,
            height: '28.59px',
            padding: '0 6px'
        }),

        input: (provided, state) => ({
            ...provided,
            margin: '0px',
        }),
        indicatorSeparator: state => ({
            display: 'none',
        }),
        indicatorsContainer: (provided, state) => ({
            ...provided,
            height: '28.59px',
        }),
        menuPortal: (base) => ({
            ...base,
            zIndex: 9999, 
        }),
    };

    const generateForm = () => {
        return headers?.map((header, index) => {
            if (header.typeOfInput === 'input') return <div className={props.formType === 'modal' ? (index != 0) ? "mt-3" : "" : 'mr-3'}><MDBInput id={index === 0 ? 'elemFirst' : `elem${header.key.charAt(0).toUpperCase() + header.key.slice(1)}`} type="text" className="form-control-sm" label={header.columnName} value={referenceObj?.[header.key] ? referenceObj?.[header.key] : ""} onChange={(e) => setReferenceObj({ ...referenceObj, [header.key]: e.target.value })} name={header.key} />
                {errors?.[header.key] != '' && <span className='error'>{errors?.[header.key]}</span>}
            </div>
            if (header.typeOfInput === 'select') return <div className={`myClassName ${index !== 0 ? "mt-3" : ""} ${props.formType !== 'modal' ? "mr-3" : "mt-3"}`} style={{ minWidth: "200px" }}><Select id={index === 0 ? 'elemFirst' : `elem${header.key.charAt(0).toUpperCase() + header.key.slice(1)}`} menuPortalTarget={(table !== 'Warehouses' || table !== 'Projects') && document.body} className="" placeholder={`${header.columnName}`} autosize={true} options={header.options} value={header.options ? header.options?.filter(v => v.value == referenceObj?.[header.key]) : { value: 0, label: '' }} onChange={(e) => { setReferenceObj({ ...referenceObj, [header.key]: e.value, [header.subItem]: '', warehouseName: '' }); header.backData ? props.backData(e) : ''; }} name={header.key} styles={selectStyles} />
                {errors?.[header.key] != '' && <span className='error'>{errors?.[header.key]}</span>}
            </div>
            if (header.typeOfInput === 'inputNumber') return <div className={props.formType === 'modal' ? (index != 0) ? "mt-3" : "" : 'mr-3'}><MDBInput id={index === 0 ? 'elemFirst' : `elem${header.key.charAt(0).toUpperCase() + header.key.slice(1)}`} type="number" className={referenceObj?.[header.key] ? "form-control-sm active ~ form-label mb-0" : "form-control-sm"} label={header.columnName} value={referenceObj?.[header.key] ? referenceObj?.[header.key] : ""} onChange={(e) => setReferenceObj({ ...referenceObj, [header.key]: e.target.value })} name={header.key} />
                {errors?.[header.key] != '' && <span className='error'>{errors?.[header.key]}</span>}
            </div>

            if (header.typeOfInput === 'switch')
                return <div className={`myClassName ${index !== 0 ? "mt-3" : ""} ${props.formType !== 'modal' ? "mr-3" : "mt-3"}`} style={{ minWidth: "200px" }}>
                    <Switch
                        name={header.key}
                        onColor="#86d3ff"
                        onHandleColor="#2693e6"
                        handleDiameter={25}
                        width={55}
                        height={20}
                        uncheckedIcon={<span style={{ display: 'flex', margin: '-4px 0 0 -5px', color: '#fff' }}>{helper().translate('NO')}</span>}
                        checkedIcon={<span style={{ display: 'flex', margin: '-4px 0 0 -5px', color: '#fff' }}>{helper().translate('YES')}</span>}
                        padding="7px 0px"
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                        checked={referenceObj?.[header.key]}
                        onChange={(e) => { header.onlyTrue ? e ? setReferenceObj({ ...referenceObj, [header.key]: e }) : 0 : setReferenceObj({ ...referenceObj, [header.key]: e }); }}
                    />
                    {errors?.[header.key] != '' && <span className='error'>{errors?.[header.key]}</span>}
                </div>
            if (header.typeOfInput === "dontShow") {
                return <></>
            }
        });

    }

    const renderForm = () => {
        //var headers = getFields();
        if (props.formType !== "modal") {
            return generateForm();
        }
        else {
            return <Modal
                show={show}
                onHide={modalClose}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton className="no-shadow btn-header px-3 py-0">
                    {/* <Modal.Title>{ referenceObj.id != 0 ? 'Edit' : 'Add new'}</Modal.Title> */}
                    <HeaderTools save={() => save()} />
                </Modal.Header>
                <Modal.Body closeButton className="px-3">

                    {generateForm()}
                </Modal.Body>
            </Modal>
        }
    }

    const setSPValueZero = (id, vatType, vat, SaleOrPurchase, table) => {

        let params = `&id=${id}&vatT=${vatType}&vat=${vat}&sP=${SaleOrPurchase}`;
        apiService()
            .query("setSalePurchaseVatZero", params)
            .then((response) => {
                if (response.success) {
                    getReferenceData(table)
                }
                else {
                    alert("Error: getting Pagesat" + response.errorMessage);
                }
            });
    }

    const validate = async () => {
        let errorsArr = []
        await headers.map((header, index) => {
            if (header.required) {
                // console.log(!referenceObj?.[header.key])
                if (referenceObj?.[header.key] === 0 ? false : !referenceObj?.[header.key]) {
                    errorsArr[header.key] = 'Cannot be blank'

                }
            }
        });

        setErrors(errorsArr)
        return returnValidate(errorsArr);
    }

    const returnValidate = (errors) => {
        if (Object.values(errors).every(x => x === null || x === '')) {
            return true
        }
        else {
            return false
        }
    }

    const save = () => {
        referenceObj.createdBy = globals().getLogedInUser().data.username;
        referenceObj.id !== 0 ? referenceObj.changedBy = globals().getLogedInUser().data.username : referenceObj.changedBy = "";
        referenceObj.id !== 0 ? referenceObj.changedAt = new Date() : referenceObj.changedAt = "";
        validate().then(function (result) {
            if (result) {
                if (referenceObj.id !== 0 && referenceObj.id !== null) {
                    apiService().put(table, referenceObj)
                        .then((response) => {
                            if (table === 'projects') {
                                if (response.success) {
                                    apiService().put('updateDefaultProject', { id: referenceObj.id, warehouseId: referenceObj.warehouseId })
                                        .then((response) => {
                                            responseMessage(response, 'Updated Successfully')
                                        })
                                }
                                else {
                                    responseMessage(response, 'Updated Successfully')
                                }
                            } else if (table === "purchaseVat" || table === "saleVat") {
                                let sP = 0
                                table === "purchaseVat" ? sP = 0 : sP = 1
                                referenceObj.defaultVat === 1 && setSPValueZero(parseInt(referenceObj.id), parseInt(referenceObj.vatType), parseInt(referenceObj.vat), parseInt(sP), table)
                            }

                            responseMessage(response, 'Updated Successfully')

                        });
                }
                else {
                    apiService().post(table, referenceObj)
                        .then((response) => {
                            // console.log(referenceObj)
                            // console.log(table)

                            if (response.success && (table === "purchaseVat" || table === "saleVat")) {
                                let paramsForSp = `&sp=${parseInt(referenceObj.saleOrPurchase)}`;

                                apiService()
                                    .query("getLastInsertSalePurchaseVat", paramsForSp)
                                    .then((response) => {
                                        if (response.success) {
                                            referenceObj.defaultVat === 1 && setSPValueZero(parseInt(response.data[0].id), parseInt(referenceObj.vatType), parseInt(referenceObj.vat), parseInt(referenceObj.saleOrPurchase), table)
                                        }
                                        else {
                                            alert("Error: getting getLastInsertSalePurchaseVat" + response.errorMessage);
                                        }
                                    });
                            }
                            responseMessage(response, 'Saved Successfully')
                        });
                }
            }
        });
    }

    const remove = (id) => {
        if (props.table === 'vatlevel') {
            var params = `&vat=${id}`;
            apiService()
                .query("vatExist", params)
                .then((response) => {
                    if (response.success) {
                        let res = response.data.length
                        if (res === 0) {
                            deleteItem(id)
                        } else {
                            addToast('Nuk mund të fshini Taksen sepse ka artikull apo faturë që përmban këtë vlerë', { appearance: 'warning', autoDismiss: true, });
                        }
                    }
                    else {
                        alert("Error: getting Pagesat" + response.errorMessage);
                    }
                });

        } else {
            deleteItem(id);
        }

    }

    const deleteItem = (id) => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className="custom-ui" >
                        <h1>A jeni te sigurt?</h1>
                        <p>Dëshironi të fshini këtë artikull?</p>
                        <button
                            onClick={() => {
                                apiService().delete(table, id)
                                    .then((response) => { responseMessage(response, 'Delete Successfully') });
                                onClose();
                            }}
                        >
                            Po , Fshije!
                        </button>
                        <button onClick={onClose}>Jo</button>
                    </div>
                );
            }
        })
    }

    const responseMessage = (response, message) => {
        if (response.success) {
            getReferenceData(table);
            addToast(message, { appearance: 'success', autoDismiss: true, });
            if (show) modalClose()
        }
        else {
            addToast('Ka ndodhur nje gabim!', { appearance: 'error', autoDismiss: true, });
        }
    }

    const escFunction = (event) => {
        if (event.keyCode === 27) {
            setAddReference(false)
        }
    }

    const searchResult = () => {
        referenceData?.forEach(x => {
            if (x.isDefault === false) { x.isDefault = 0 }
            if (x.isDefault === true) { x.isDefault = 1 }
        })
        let searchItems = referenceData,
            searchString = search?.trim().toLowerCase();

        if (searchString?.length > 0) {
            //searchItems = searchItems.filter((e) => e.name.toLowerCase().match(searchString));
            searchItems = searchItems.filter(item => {
                return (
                    // headers.map((h, index) => {
                    //     return item?.[h.key]?.toString().toLowerCase().match(searchString)
                    // }) 
                    item?.saleType?.toString()?.toLowerCase()?.match(searchString) ||
                    item?.purchaseType?.toString()?.toLowerCase()?.match(searchString) ||
                    item?.name.toString().toLowerCase().match(searchString)
                    // item.id.toString().toLowerCase().match(searchString) ||
                    // item.name.toLowerCase().match(searchString) ||
                    // item.type.toLowerCase().match(searchString) 
                )
            });
            return searchItems
        }
        else {
            return searchItems
        }
    }

    useEffect(() => {
        document.addEventListener("keydown", escFunction, false);
        return () => {
            document.removeEventListener("keydown", escFunction, false);
            setNewClick(0)
        }
    }, [])

    useEffect(() => {
        getReferenceData(table);
        getType(table);
    }, [location, props.table])

    // useEffect(() => {
    //     if(addReference){
    //         getFocus();
    //     }
    // }, [addReference]);

    useEffect(() => {
        if (newClick) {
            addNewReference()
        } else {
            setNewClick(props.new + 1)
        }
    }, [props.new]);

    return (
        <>
            <div>

                {/* {props.formType !== "modal" && <HeaderTools newHandle={addNewReference} save={() => save()} />} */}
                <div className="container-fluid px-2 mt-3">
                    {props.name && <div className="card-header py-2"><h6 className="m-0 font-weight-bold text-primary text-left">{helper().translate(props.name)}</h6></div>}
                    <Search newHandle={() => addNewReference()} save={props.formType != 'modal' && addReference ? () => save() : ''} change={(e) => setSearch(e.target.value)} />

                    {addReference &&
                        <div className="card border-left-primary shadow h-100 mt-1 py-2">
                            <div className="card-body pt-0 pb-1">
                                <label className="text-xs font-weight-bold text-primary text-uppercase mb-2">{referenceObj.id != 0 ? 'Edito ' + props.name : helper().translate("ADD") + " " + helper().translate(props.name)}</label>
                                <div className="d-flex align-items-center">
                                    {renderForm()}
                                </div>
                            </div>
                        </div>
                    }

                    <div className="card shadow mt-1 mb-3">
                        {/* <div className="card-header py-2">
                            <h6 className="m-0 font-weight-bold text-primary">{table}</h6>
                        </div> */}

                        <DataTable data={searchResult()} headers={headers} edit={editReference} delete={remove} />
                    </div>
                </div>
            </div>
        </>
    )
}

export default AdministrationForm
